export default __webpack_public_path__ + "static/2.starlearners-logo 1-07368cac709f2adfb337e1703ec1e63d.png";